import { useNavigate, useParams } from "react-router-dom";
import AddShopProduct from "./AddShopProduct";

// این کامپوننت صرفاً یک «صفحه» با URL مستقل (/panel/manage-shops/:shopId/products/add)
// است که فرم مشترک AddShopProduct را در حالت «افزودن» رندر می‌کند.
export default function AddShopProductPage() {
  const { shopId } = useParams();
  const navigate = useNavigate();

  // برگشت به لیست محصولات همون فروشگاه
  const backToProducts = () => navigate(-1);

  return (
    <AddShopProduct
      shop={{ store_id: shopId }}
      product={null}
      onBack={backToProducts}
      onSubmit={backToProducts}
    />
  );
}
